<template>
  <div class="login-container">
    <div class="login-form">
      <span class="tfam-tfam"></span>
      <span class="login-title">北美館導覽系統管理後台</span>
      <input class="form-control" v-model="userModel.username" aria-describedby="addon-right addon-left" placeholder="帳號">
      <input class="form-control" type="password" v-model="userModel.password" aria-describedby="addon-right addon-left" placeholder="密碼">
      <p-button type="info"
                round
                v-loading.fullscreen.lock="loading"
                @click.native.prevent="handleLogin">
        登入
      </p-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Login",
    data() {
      return {
        userModel: {
          username: '',
          password: ''
        },
        loading: false
      }
    },
    methods: {
      handleLogin() {
        this.loading = true;
        this.$store.dispatch('LoginByUsername', this.userModel).then(() => {
          this.loading = false;
          this.$router.push({path: '/exhibitions'})
        }).catch(() => {
          this.loading = false;
        })
      }
    }
  }
</script>

<style lang="scss">
.login-container {
  background: #f0f0f0;
  position: relative;
  width: 100vw;
  height: 100vh;
  .login-form {
    position: absolute;
    width: 400px;
    height: 400px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    .tfam-tfam {
      width: 100%;
      height: 80px;
      line-height: 80px;
      font-size: 75pt;
      display: block;
      color: black;
    }
    .login-title {
      font-size: 15pt;
      padding: 15px;
      display: block;
    }
    input {
      font-size: 10pt;
      line-height: 50px;
      height: 50px;
      background: white;
      margin: 20px 0;
    }
    button {
      width: 50%;
      margin-top: 20px;
      background: #444;
      border-color: #444;
    }
  }
}
</style>
